import _toConsumableArray from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import Head from "@/components/Head/index.vue";
import Tabs from "@/components/Tabs/index.vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import Pagination from "@/components/Pagination/index.vue";
import { defineComponent, ref, reactive } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { Search } from '@element-plus/icons';
export default defineComponent({
  name: "WishCardIndex",
  components: {
    Head: Head,
    Pagination: Pagination,
    Tabs: Tabs
  },
  setup: function setup() {
    var store = useStore();
    var router = useRouter();

    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties; // 表格加载


    var loading = ref(false);
    var tableloading = globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$tipsText.$tips_tableloading; // 第一个table的初始化

    var tableData = ref([{}]);
    var totalNum = ref(0);
    var Data = reactive({
      searchContent: '',
      isactive: 0,
      form: {
        pageIndex: 1,
        pageSize: 10,
        solverExists: "0",
        solverId: '',
        title: '',
        publishStatus: 1
      }
    }); // 获取心愿分页

    function getTableOne() {
      return _getTableOne.apply(this, arguments);
    }

    function _getTableOne() {
      _getTableOne = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$globalProperti, data, total;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                loading.value = true;
                _context.next = 3;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getWishList"](Data.form);

              case 3:
                _yield$globalProperti = _context.sent;
                data = _yield$globalProperti.data;
                total = _yield$globalProperti.total;
                tableData.value = _toConsumableArray(data);
                totalNum.value = total;
                loading.value = false;

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getTableOne.apply(this, arguments);
    }

    getTableOne();

    function changPage(val) {
      Data.form.pageIndex = val;
      getTableOne();
    }

    function tabClick(_x) {
      return _tabClick.apply(this, arguments);
    } // 查看详情


    function _tabClick() {
      _tabClick = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(val) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                Data.isactive = val;
                Data.form.solverExists = val;
                Data.form.pageIndex = 1;

                if (val == 1 || val == 2) {
                  Data.form.solverId = store.state.user.user.userId;

                  if (val == 2) {
                    Data.form.solverExists = "2,3";
                  }
                } else {
                  Data.form.solverId = '';
                }

                getTableOne();

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _tabClick.apply(this, arguments);
    }

    function getDetail(_x2) {
      return _getDetail.apply(this, arguments);
    }

    function _getDetail() {
      _getDetail = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(item) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                router.push({
                  name: "wishCardDetail",
                  query: {
                    id: item.id
                  }
                });

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _getDetail.apply(this, arguments);
    }

    function searchBook() {
      return _searchBook.apply(this, arguments);
    }

    function _searchBook() {
      _searchBook = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                Data.form.pageIndex = 1;
                getTableOne();

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      return _searchBook.apply(this, arguments);
    }

    return {
      tableloading: tableloading,
      loading: loading,
      tableData: tableData,
      totalNum: totalNum,
      changPage: changPage,
      getDetail: getDetail,
      Search: Search,
      Data: Data,
      tabClick: tabClick,
      searchBook: searchBook
    };
  }
});